import React from 'react';
import { Link } from 'react-router-dom';


const NavBar = ({ user, onLogout }) => {
  return (
    <nav className="bg-gray-800">
      <div className="mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <span className="text-white font-bold text-lg"><Link to="/">Philanthropy Crawler</Link></span>
            </div>
            
              <div className="ml-10 flex">
              <Link
                  to="/"
                  className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                >
                  Dashboard
                </Link>
              <Link
                  to="/pdf-viewer"
                  className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                >
                  PDF Review
                </Link>
                <Link
                  to="/url-manager"
                  className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                >
                  URL Manager
                </Link>
                <Link
                  to="/data-import"
                  className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                >
                  Data Import
                </Link>
              </div>
              {user.role === 'admin' && (
                <Link
                  to="/users"
                  className="text-gray-300 hover:text-white px-3 py-2 rounded-md text-sm font-medium"
                >
                  Users
                </Link>
                )}
          </div>
          <div className="flex items-center">
            <div className="ml-4 flex items-center md:ml-6">
              <span className="text-gray-300 px-3 py-2 rounded-md text-sm font-medium">
                Welcome, {user.username}
              </span>
              <button
                onClick={onLogout}
                className="ml-3 px-3 py-2 rounded-md text-sm font-medium text-white bg-red-600 hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
              >
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default NavBar;
